import SvgContainer from "src/components/SvgContainer";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { ReactComponent as LowLightAuto } from "./icons/low-light-auto.svg";
import { ReactComponent as LowLightOff } from "./icons/low-light-off.svg";
import { ReactComponent as Arrow } from "./icons/arrow-right.svg";
import Container from "./components/Container";
import Text from "./components/Text";
import getColors from "./getColors";
import LowLightMenu from "../components/LowLightMenu";
import { useControls } from "src/utils/createControls";

export default function LowLightIndicator({
  mode,
  error,
  activity,
  isDarkMode,
  lowLightMode,
  openLowLightMenu,
  ...rest
}) {
  const { bg, color } = getColors({ isDarkMode, activity, mode, error });
  const { t } = useTranslation();
  const menu = useControls();
  return (
    <LowLightMenu
      lowLightRef={
        <Box>
          <Container
            p={["6px 12px", "8px 16px"]}
            bg={bg}
            onClick={menu.open}
            {...rest}
          >
            <SvgContainer
              fill={color}
              size={["16px", "20px"]}
              icon={lowLightMode === "LL_AUTO" ? LowLightAuto : LowLightOff}
            />
            <Text
              color={color}
              fontSize={["12px", "16px", "20px"]}
              mx={["4px", "6px", "8px"]}
              lineHeight="1"
            >
              {t("Low light")}
            </Text>

            <SvgContainer fill={color} size="16px" icon={Arrow} />
          </Container>
        </Box>
      }
      isOpen={menu.isOpen}
      onClose={menu.close}
      lowLightMode={lowLightMode}
    />
  );
}
